import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import {
  useSelectedRecommendedProjectSelector,
  useCurrentGeoRasterDataSelector,
  useCurrentDataLayerTypeSelector,
} from "../../../../store/projects/selectors";
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

type ChartData = {
  labels: any[];
  values: any[];
};

const ReBioDiversityAccordionBody = () => {
  const selectedReProject = useSelectedRecommendedProjectSelector();
  const geoRasterData = useCurrentGeoRasterDataSelector();
  const currentLayer = useCurrentDataLayerTypeSelector();

  useEffect(() => {
    if (currentLayer === "biodiversity" && geoRasterData) {
      processChartData(geoRasterData?.data);
    }
  }, [selectedReProject, geoRasterData]);

  const processChartData = async (geoRasterData: any) => {
    let pixelArea: number;
    // const degreesToHectares = 12362851;
    if (geoRasterData.pixelHeight && geoRasterData.pixelWidth) {
      // pixelArea = geoRasterData.pixelHeight * 1000000 * (geoRasterData.pixelWidth * 1000000);
      pixelArea = 1000 * 1000;
      const values = geoRasterData.values[0];
      const bioDiversityValues: any = {};
      const pixelAreaHectares = pixelArea / 10000;
      // Loop through each pixel
      for (let y = 0; y < geoRasterData.height; y++) {
        for (let x = 0; x < geoRasterData.width; x++) {
          const pixelValue = values[y][x];

          if (pixelValue > 0) {
            // Initialize the count for the year if it doesn't exist
            if (!bioDiversityValues[pixelValue]) {
              bioDiversityValues[pixelValue] = 0;
            }

            // Increment the count for the corresponding year
            bioDiversityValues[pixelValue]++;
          }
        }
      }

      // Calculate the total forest loss area for each year
      const bioDiversityArea: any = {};
      for (const entry in bioDiversityValues) {
        const count = bioDiversityValues[entry];
        bioDiversityArea[entry] = count * pixelAreaHectares; // Total area in hectares
      }

      // Extract chart data
      const labels = Object.keys(bioDiversityArea);
      const chartValues = Object.values(bioDiversityArea);

      // Set chart data
      setChartData({
        labels: labels,
        values: chartValues,
      });
    } else {
      console.error("insufficient data to calculate the area");
    }
  };

  const [chartData, setChartData] = useState<ChartData>({
    labels: [],
    values: [],
  });

  const options = {
    plugins: {
      title: {
        display: true,
        text: "biodiveristy",
      },
      legend: {
        display: false,
        position: "bottom" as const,
      },
    },
    responsive: true,
    interaction: {
      mode: "index" as const,
      intersect: false,
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "biodiveristy values",
        },
        grid: {
          display: false,
        },
      },
      y: {
        title: {
          display: true,
          text: "Area(Hectares)",
        },
        grid: {
          display: true,
        },
      },
    },
  };

  const data = {
    labels: chartData.labels,
    datasets: [
      {
        // label: "lulc",
        display: false,
        data: chartData?.values,
        backgroundColor: "#482F8B",
        barThickness: 16,
        barPercentage: 0.5,
      },
    ],
  };

  return (
    <div className="font-primary">
      <div>
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

export default ReBioDiversityAccordionBody;
